// extracted by mini-css-extract-plugin
module.exports = {"section":"FeaturedCaseSection_section__TPpDo","sentinel":"FeaturedCaseSection_sentinel__PP_Dz","loadingText":"FeaturedCaseSection_loadingText__5905G"};